import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Components
import Service from 'components/atoms/Service';
import SelectAllButton from 'components/atoms/SelectAllButton';

// Constants
import { SERVICES_TYPE } from 'constants/services';

// Utils
import { splitCamelCase } from 'utils/string';
import { isObjEmpty } from 'utils/varValidation';

import './ServicesList.scss';

const ns = 'services-list';

class ServicesList extends React.Component {
  constructor(props) {
    super(props);
    this.clickHandler = this.clickHandler.bind(this);
    this.selectAllServices = this.selectAllServices.bind(this);
    this.state = {
      selectAll: false
    };
  }

  componentDidMount() {
    this.checkAllServices();
  }

  selectAllServices(ev) {
    ev.preventDefault();
    const { selectAll } = this.state;
    const { serviceList, services, addService, removeService } = this.props;
    serviceList.forEach(service => {
      const isSelected = services.find(
        serviceArray => serviceArray.id === service.id
      );
      if (!isSelected && !selectAll) {
        addService(service);
      } else if (isSelected && selectAll) {
        removeService(service.id);
      }
    });
    this.setState({ selectAll: !selectAll });
  }

  checkAllServices(serviceId) {
    const { serviceList, services } = this.props;
    const servicesAvailable = serviceList.map(service => service.id);
    const servicesSelected = services
      .map(service => service.id)
      .filter(id => servicesAvailable.indexOf(id) > -1);
    if (serviceId) {
      servicesSelected.push(serviceId);
    }
    if (
      servicesSelected.sort().toString() === servicesAvailable.sort().toString()
    ) {
      this.setState({ selectAll: true });
    }
  }

  clickHandler(service, comment) {
    const {
      dmsOpcode,
      name,
      price,
      discountedPrice,
      shopDurationMins,
      id,
      serviceKind,
      priceCaption,
      quoteServiceId
    } = service;
    const {
      services,
      addService,
      removeService,
      removePackageService,
      gtmUserEvent,
      group,
      packageServices,
      updateReadOnlyServices
    } = this.props;
    const formattedService = {
      dmsOpcode,
      id,
      name,
      price,
      discountedPrice,
      serviceKind,
      priceCaption,
      quoteServiceId
    };
    if (comment) {
      formattedService.notes = comment;
    }
    if (shopDurationMins) {
      formattedService.shopDuration = shopDurationMins;
    }
    const includedService = packageServices
      ? packageServices.find(packageService => packageService.id === id)
      : null;
    const isGlobalRepair = serviceKind === 'global_repair';
    if (includedService) {
      removePackageService(includedService.id);
    } else {
      const findCallback = servicesArray => {
        let found = servicesArray.id === id;
        if (isGlobalRepair) {
          found = servicesArray.quoteServiceId === quoteServiceId;
        }
        return found;
      };
      if (!services.find(findCallback)) {
        addService(formattedService);
        this.checkAllServices(formattedService.id);
        gtmUserEvent(
          'Service',
          'Selected',
          'Service Added To Appointment',
          `GTM_CURRENT_PAGE > ${splitCamelCase(group)} Services Section`,
          name
        );
      } else {
        this.setState({ selectAll: false });
        removeService(!isGlobalRepair ? id : quoteServiceId);
      }
    }

    if (quoteServiceId) {
      updateReadOnlyServices(service);
    }
  }

  render() {
    const {
      serviceList,
      className,
      services,
      packageServices,
      showSelectAll
    } = this.props;
    const { selectAll } = this.state;
    const totalPrice = serviceList.reduce((a, b) => a + b.price, 0);
    const classProps = classNames(ns, className);
    const isListEmpty = !showSelectAll && serviceList.length === 0;
    return (
      <div className={classProps} role={isListEmpty ? '' : 'list'}>
        {showSelectAll && (
          <SelectAllButton
            isSelected={selectAll}
            price={totalPrice}
            onClick={ev => this.selectAllServices(ev)}
          />
        )}
        {serviceList.map(service => {
          const {
            id,
            status,
            promotion,
            quoteServiceId,
            serviceKind
          } = service;
          const isGlobalRepair = serviceKind === 'global_repair';
          const isReadOnly = false;
          let isSelected = Boolean(
            services.find(serviceArray => +serviceArray.id === id)
          );
          if (isGlobalRepair) {
            isSelected = Boolean(
              services.find(
                serviceArray => +serviceArray.quoteServiceId === quoteServiceId
              )
            );
          }
          let isIncluded = false;
          let isOptional = 'NO REMEDY' !== status;
          if (packageServices && packageServices.length > 0) {
            const packageService = packageServices.find(
              serviceArray => serviceArray.id === id
            );
            isIncluded = Boolean(packageService);
            if ('NO REMEDY' !== status) {
              isOptional = packageService ? packageService.selectable : true;
            }
          }
          return (
            <Service
              key={id}
              service={service}
              onSelect={this.clickHandler}
              isSelected={isSelected || isIncluded}
              includedInPackage={isIncluded}
              type={SERVICES_TYPE.ALACARTE}
              isOptional={isOptional}
              promotion={promotion}
              readOnly={isReadOnly && !isObjEmpty(isReadOnly)}
            />
          );
        })}
      </div>
    );
  }
}

ServicesList.propTypes = {
  addService: PropTypes.func.isRequired,
  className: PropTypes.string,
  group: PropTypes.string,
  gtmUserEvent: PropTypes.func.isRequired,
  packageServices: PropTypes.array,
  removePackageService: PropTypes.func.isRequired,
  removeService: PropTypes.func.isRequired,
  serviceList: PropTypes.array.isRequired,
  services: PropTypes.array,
  showSelectAll: PropTypes.bool,
  isQuoteAppt: PropTypes.bool.isRequired,
  readOnlyServices: PropTypes.array,
  updateReadOnlyServices: PropTypes.func.isRequired
};

ServicesList.defaultProps = {
  showSelectAll: false
};

export default ServicesList;



// WEBPACK FOOTER //
// ./src/components/molecules/ServicesList/ServicesList.js